(function () {

    var module = angular.module('app');

    module.directive('contact', function () {
        return {
            restrict: 'E',
            templateUrl: '/app/features/contact/contact.tpl.html',
            scope: {},
            controller: 'contactCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    });

    module.controller('contactCtrl', [
        '$http', 'loading', '$state',
        function (http, loading, state) {
            var vm = this;
            vm.model = {};

            vm.tracker = loading.createTracker();

            vm.submit = function () {
                vm.tracker.track(
                    http.post('/api/contact', vm.model)
                    .then(function () {
                        toastr.success('Thank you! We will be in touch soon.');
                        state.go('home');
                    })
                );
            }
        }
    ]);
}());